// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_k2-0";
export var buttonContainer = "_k2-3";
export var cancelButton = "_k2-4";
export var headerSection = "_k2-6";
export var headerTitle = "_k2-9";
export var messageSideLeft = "_k2-1";
export var messageSideRight = "_k2-2";
export var orderNumberContainer = "_k2-7";
export var orderNumberLabel = "_k2-8";
export var submitButton = "_k2-5";